/**
 * @author vishwadeep.kapoor
 * @Date: 2020-10-06 17:03:58
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-10-27 16:07:58
 */
import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';
import endPoints from '../../config/endPoints';
import { PROFILE_LEFT_NAV } from './constants';
import { ProfileNavigationProps, ProfileNavigationMapStateToProps, ProfileNavigationMapDispatchToProps } from './profileDataHandler';
import { constants, utils, eventTracking } from '../../devUtils';

const StyledManipalCignaMobileLink = styled.div`
  display: none;
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[0]}) {
    display: block;
    position: absolute;
    top: 15px;
    right: 15px;
    a{
     color: ${(props) => props.theme.blackColor};
    }

    img{
      height: 20px;
      padding-right: 10px;
    }
  }
`;

class ProfileNavigation extends PureComponent {
  constructor() {
    super();
    this.handleLogout = this.handleLogout.bind(this);
    this.handleModal = this.handleModal.bind(this);
  }

  handleModal(modalType) {
    const { history } = this.props;
    switch (modalType) {
      case 'GIFT_CARD_OTP':
        utils.forceRedirect(history, { pathname: constants.LINK_MY_EVOUCHERS });
        break;
      default:
        break;
    }
  }

  handleLogout() {
    const { history, onUserLogout, UserDetails: { client_series = '' } = {} } = this.props;
    onUserLogout(history, { client_series });
  }

  render() {
    const {
      history: { location: { pathname } },
      UserDetails: {
        ybl_cards_enabled,
        ybl_physical_card,
        ybl_physical_card_linked,
        ybl_kyc_done,
        isOnlyMerchandise = false,
        ybl_activation_by,
        client_series = '',
      } = {},
      cardData: {
        card_name = '',
      } = {},
    } = this.props;
    return (
      <Fragment>
        <div className="profile_left">
          <input type="checkbox" id="check_id" />
          <label htmlFor="check_id"></label>
          <ul>
            <span></span>
            {PROFILE_LEFT_NAV
              .filter(({ key }) => {
                if (client_series === endPoints.LYRA_SERIES) {
                  return key === 1;
                }
                return isOnlyMerchandise ? ![3, 5].includes(key) : key !== -1;
              })
              .filter(({ key }) => (ybl_physical_card && !ybl_physical_card_linked && ybl_kyc_done && ybl_activation_by !== 'zaggle' ? true : key !== 7))
              .filter(({ key }) => (ybl_cards_enabled ? true : key !== 6))
              .map(({ value, link, key, icon }) => (
                <li key={key} className={pathname === link ? 'active' : ''}>
                  {link === constants.LINK_MY_EVOUCHERS ?
                    <div role="presentation" onClick={() => this.handleModal('GIFT_CARD_OTP')}>
                      <img src={icon} alt="no_image" /><strong>{value}</strong>
                    </div> :
                    <Link to={link || '/'}>
                      <img src={icon} alt="no_image" /><strong>{value}</strong>
                    </Link>
                  }
                </li>
              ))}
            {client_series !== endPoints.LYRA_SERIES &&
            <li>
              <Icon type="file-pdf" />
              <a
                href={endPoints.DISPUTE_FORM}
                target="_blank"
                onClick={() => eventTracking.triggerEvent('Manage Network Cards', 'Download Dispute Form', card_name)}
              >Download Dispute form
              </a>
            </li>
            }
            <li onClick={this.handleLogout} role="presentation"><img src={endPoints.PROFILE_LOGOUT.URL} alt="" /><strong>Logout</strong></li>
          </ul>
          {isOnlyMerchandise ? (
            <StyledManipalCignaMobileLink>
              <Link to={constants.LINK_MY_ORDERS}>
                <img src={endPoints.PROFILE_ORDER.URL} alt="no_image" />My Orders
              </Link>
            </StyledManipalCignaMobileLink>
          ) : ''}
        </div>
      </Fragment>
    );
  }
}

ProfileNavigation.defaultProps = {
  isOnlyMerchandise: false,
};

ProfileNavigation.propTypes = ProfileNavigationProps;

const component = connect(ProfileNavigationMapStateToProps, ProfileNavigationMapDispatchToProps)(ProfileNavigation);
export { ProfileNavigation };

export default component;



// WEBPACK FOOTER //
// client/containers/Profile/ProfileNavigation.jsx